import NewThreadModal from "features/NewThreadButton/components/NewThreadModal";
import { useSidebar } from "hooks/useSidebar";
import { useAppSelector } from "hooks/useStore";
import SidebarCollapsedContent from "./components/SidebarCollapsedContent";
import SidebarContent from "./components/SidebarContent";

function Sidebar() {
  const { toggleSidebar, isSidebarOpen } = useSidebar();
  const is898WideScreen = useAppSelector(
    (state) => state.setting.is898WideScreen
  );

  const expandSidebar = () => {
    toggleSidebar();
  };

  const showCollapsedSidebar = !is898WideScreen;

  return (
    <div
      className="z-40 h-full border-r overflow-x-hidden bg-bg-base"
      data-testid="sidebar-container"
    >
      {isSidebarOpen ? (
        <SidebarContent />
      ) : showCollapsedSidebar ? (
        <SidebarCollapsedContent onExpand={expandSidebar} />
      ) : null}
      <NewThreadModal />
    </div>
  );
}

export default Sidebar;
